import { render, staticRenderFns } from "./messageContentDialog.vue?vue&type=template&id=538b92ce&scoped=true&"
import script from "./messageContentDialog.vue?vue&type=script&lang=js&"
export * from "./messageContentDialog.vue?vue&type=script&lang=js&"
import style0 from "./messageContentDialog.vue?vue&type=style&index=0&id=538b92ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b92ce",
  null
  
)

export default component.exports